import { render, staticRenderFns } from "./appListCenter.vue?vue&type=template&id=5e27becc&scoped=true&"
import script from "./appListCenter.vue?vue&type=script&lang=js&"
export * from "./appListCenter.vue?vue&type=script&lang=js&"
import style0 from "./appListCenter.vue?vue&type=style&index=0&id=5e27becc&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e27becc",
  null
  
)

export default component.exports